'use client'
import { FC, forwardRef } from 'react'
import cn from 'classnames'
import { MktuClassWord } from '@/services/Api/generated'
import { Loading } from '@/components/Loading'
import { Word } from '@/domains/Account/modules/Mktu/components'
import { TypeOfView } from '@/shared/Mktu/components/ListViewToggle'
import styles from './WordList.module.scss'
import { observer } from 'mobx-react-lite'

interface WordListProps {
  className?: string
  words: MktuClassWord[]
  selectedWordNames: MktuClassWord['word'][]
  typeOfView: TypeOfView
  isLoadingWords?: boolean
  isReadonly?: boolean
  onSelectWord: (word: MktuClassWord['word']) => void
  ref?: React.Ref<HTMLDivElement>
}

export const WordList: FC<WordListProps> = observer(
  ({
    className,
    words,
    selectedWordNames,
    typeOfView,
    isLoadingWords = false,
    isReadonly = false,
    onSelectWord,
    ref,
  }) => {
    if (isLoadingWords) {
      return <Loading withText={false} />
    }

    return (
      <div
        className={cn(styles.container, className, {
          [styles.isList]: typeOfView === TypeOfView.List,
        })}
        ref={ref}
      >
        {words.map((item) => {
          const isSelected = selectedWordNames.includes(item.word)
          return (
            <Word
              key={item.uuid}
              id={item.word}
              name={item.word}
              onClick={onSelectWord}
              isSelected={isSelected && !isReadonly}
              isDeletable={isSelected && !isReadonly}
              isReadonly={isReadonly}
              isNice={item.isNice}
            />
          )
        })}
      </div>
    )
  }
)
